import { useMutation } from "@tanstack/react-query";
import { useLocation, useNavigate } from "@tanstack/react-router";

import { privateApi } from "@/api/axios";
import { useToastStore } from "@/components";
import type { UpdateSubscriptionRequest } from "@/domains/careplan/models/types";

const updateSubscription = async ({ careplanId, cartId }: UpdateSubscriptionRequest) => {
  await privateApi.put(`/careplans/${careplanId}/subscription`, {
    cartId,
  });
};

export const useUpdateSubscription = () => {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const pushToast = useToastStore((state) => {
    return state.pushToast;
  });

  return useMutation({
    mutationFn: updateSubscription,
    onSuccess: () => {
      navigate({
        to: pathname,
        search: {
          ...search,
          subscription_processing: true,
        },
        replace: true,
        resetScroll: false,
      });
    },
    onError: async () => {
      await pushToast({
        type: "error",
        title: "Update Failed",
        message: "We couldn't update your subscription. Please try again.",
      });
    },
  });
};
